<template>
  <v-dialog v-model="resultsDialog" width="780">
    <template v-slot:activator="{ on }">
      <mf-button class="mr-1" label="Exportar relatório por loja" v-on:click.native="on.click" />
    </template>
    <v-card v-if="resultsDialog">
      <v-card-title>
        <span class="section-title">Relatório por loja</span>
        <p class="texto-corrido mt-1 mb-0" style="word-break: normal; font-size: 16px">
          Esse relatório expõe o resultado por produto ofertado nessa campanha e também por lojas onde a campanha esteve ativa.
        </p>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-row class="mx-3">
          <v-col cols="12" class="pb-0">
            <p class="ma-0 cinza-0-text">{{ checkboxDescription }}</p>
          </v-col>
          <section v-for="option in checkboxOptionsGroups" :key="option.label" class="py-0 px-2" :style="{ width: option.width }">
            <v-checkbox
              v-model="selectedGroups"
              :value="option.value"
              :label="option.label"
              color="cinza-0"
              multiple
              hide-details
              class="texto-corrido"
              :disabled="option.required"
            />
          </section>
          <v-col cols="12" class="pb-0">
            <p class="ma-0 cinza-0-text">Agora selecione os dados que gostaria de ter:</p>
          </v-col>
          <section v-for="option in checkboxOptionsFields" :key="option.label" class="py-0 px-2" :style="{ width: option.width }">
            <v-checkbox
              v-model="selectedFieldsComputed"
              :value="option.value"
              :label="option.label"
              :disabled="option.required"
              color="cinza-0"
              multiple
              :error="errorFields"
              class="texto-corrido"
            />
          </section>
        </v-row>
        <include-emails-table ref="includeEmailsTable" :emails.sync="emails" :max-emails-to-scroll="4" scroll-height="192px" />
      </v-card-text>
      <v-card-actions class="d-flex justify-end mr-2">
        <mf-button class="mr-3" text label="Cancelar" @click="closeModal" />
        <export-data async :loading="exportLoading" @file-format="getFileFormat"></export-data>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { MUTATION_SEND_CAMPAIGN } from '../../graphql'
import { required } from 'vuelidate/lib/validators'
import ExportData from '../../../../../components/export-data/ExportData.vue'
import IncludeEmailsTable from '@/components/export-email-report/IncludeEmailsTable.vue'
export default {
  name: 'ExportReportByUnit',
  components: {
    ExportData,
    IncludeEmailsTable,
  },
  props: {
    franchise: Boolean,
    offerSalesType: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    exportLoading: false,
    resultsDialog: false,
    hasValidationError: false,
    offerScheduleId: '',
    errorFields: false,
    selectedGroups: ['UNIT'],
    selectedFields: [],
    emails: [],
    fileFormat: 'CSV',
  }),
  computed: {
    selectedFieldsComputed: {
      get() {
        let offerTypeValue = ''
        if (this.getOfferType === 'cashback') {
          offerTypeValue = 'CASHBACK'
        } else if (this.getOfferType === 'points') {
          offerTypeValue = 'POINTS'
        }
        if (offerTypeValue.length) {
          return this.selectedFields.length ? this.selectedFields : [offerTypeValue]
        } else return this.selectedFields
      },
      set(value) {
        this.selectedFields = value
      },
    },
    getOfferType() {
      switch (this.offerSalesType) {
        case 'points_offer_sales':
          return 'points'
        case 'cashback_absolute_offer_sales':
        case 'cashback_percentage_offer_sales':
        case 'next_buy_cashback_offer_sales':
          return 'cashback'
        default:
          return 'discount'
      }
    },
    getOfferTypeEnum() {
      switch (this.offerSalesType) {
        case 'points_offer_sales':
          return 'POINTS'
        case 'cashback_absolute_offer_sales':
          return 'CASHBACK_ABSOLUTE'
        case 'cashback_percentage_offer_sales':
          return 'CASHBACK_PERCENTAGE'
        case 'next_buy_cashback_offer_sales':
          return 'NEXT_BUY_CASHBACK'
        case 'offer_sales':
        case 'dynamic_pricing_percentage_offer_sales':
          return 'GENERAL'
        case 'percentage_offer_sales':
          return 'PERCENTAGE'
        case 'takepay_offer_sales':
          return 'TAKEPAY'
        case 'combo_offer_sales':
          return 'COMBO'
        case 'cross_sell_offer_sales':
          return 'CROSS_SELL'
        case 'benefits_offer_sales':
          return 'BENEFITS'
        case 'dynamic_rule_offer_sales':
          return 'DYNAMIC_RULE'
        default:
          return ''
      }
    },
    checkboxDescription() {
      return `Selecione quais dimensões você quer ter no seu relatório:`
    },
    checkboxOptionsGroups() {
      const list = [
        {
          label: 'Loja',
          value: 'UNIT',
          width: '14.7%',
          required: true,
        },
        {
          label: 'Produto',
          value: 'PRODUCT',
          width: '16%',
        },
        {
          label: 'Dia',
          value: 'DAY',
          width: '15%',
        },
      ]

      return list
    },
    checkboxOptionsFields() {
      const points = {
        label: 'Pontos distribuídos',
        value: 'POINTS',
        width: '27%',
        required: true,
      }
      const cashback = {
        label: 'Cashback distribuído',
        value: 'CASHBACK',
        width: '27%',
        required: true,
      }
      const discount = {
        label: 'Desconto concedido',
        value: 'DISCOUNT_GRANTED',
        width: '27%',
        required: false,
      }
      const list = [
        {
          label: 'Clientes',
          value: 'CLIENTS',
          width: '14.5%',
          required: false,
        },
        {
          label: 'Cupons',
          value: 'COUPONS',
          width: '13.5%',
          required: false,
        },
        {
          label: 'Faturamento',
          value: 'REVENUE',
          width: '19%',
          required: false,
        },
        ...(this.getOfferType === 'cashback' ? [{ ...cashback }] : []),
        ...(this.getOfferType === 'points' ? [{ ...points }] : []),
        ...(this.getOfferType === 'discount' ? [{ ...discount }] : []),
      ]

      return list
    },
    headers() {
      return [
        {
          text: 'E-mail',
          value: 'email',
          width: '62.5%',
          sortable: false,
        },
        {
          text: 'Limpar lista',
          value: 'action',
          width: '15%',
          sortable: false,
          align: 'right',
        },
      ]
    },
  },
  methods: {
    closeModal() {
      this.resultsDialog = false
    },
    getFileFormat(value) {
      this.fileFormat = value
      this.validateFields()
    },
    selectedCondition(pointsCondition, cashbackCondition) {
      if (this.$getAllowedModules()['points'] && !this.$getAllowedModules()['cashback']) return pointsCondition
      else if (this.$getAllowedModules()['cashback'] && !this.$getAllowedModules()['points']) return cashbackCondition
      else return {}
    },
    async exportReport() {
      const isValid = this.$refs.includeEmailsTable.isValid()
      if (!isValid) return
      this.exportLoading = true
      await this.$apollo
        .mutate({
          mutation: MUTATION_SEND_CAMPAIGN,
          variables: {
            offersScheduleId: this.$route.params.id,
            emails: this.emails,
            groupers: this.selectedGroups,
            fields: this.selectedFieldsComputed,
            franchise: this.franchise,
            offerType: this.getOfferTypeEnum,
            fileFormat: this.fileFormat.toUpperCase(),
          },
          context: {
            uri: this.$microservicesUrls['asyncJobs'],
          },
        })
        .then(() => {
          this.exportLoading = false
          this.$snackbar({ message: this.$t('reports.processing') })
          this.clearFieldsAndClose()
        })
        .catch((error) => {
          console.log(error)
          this.exportLoading = false
          this.$snackbar({ message: 'Erro ao exportar relatório', snackbarColor: 'error' })
        })
    },
    validateFields() {
      this.$v.$reset()
      this.$v.$touch()

      if (this.$v.selectedFieldsComputed.$error) {
        this.errorFields = true
        this.$snackbar({ message: 'Preencha todos os campos corretamente.', snackbarColor: 'error' })
        return
      } else this.errorFields = false

      this.exportReport()
    },
    clearFieldsAndClose() {
      this.errorFields = false
      this.selectedGroups = ['UNIT']
      this.selectedFieldsComputed = []
      this.emails = []
      this.resultsDialog = false
    },
  },
  validations: {
    selectedFieldsComputed: {
      required,
    },
  },
}
</script>

<style scoped lang="scss">
.v-text-field__details {
  margin-bottom: 0 !important;
}
.cinza-0-text {
  color: $cinza-0;
}
</style>
